import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MatDialog } from '@angular/material/dialog'
import { Subscription } from 'rxjs'
import { UploadImageComponent } from 'src/app/shared/components/upload-image/upload-image.component'
import { ImageUpload } from 'src/app/shared/models/general.models'
import {
	BranchPayoutMethod,
	payoutDetatilsSpPopUp,
} from '../../models/sp-payout.models'
import { PayoutService } from '../../services/payout.service'
import { ActivatedRoute } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { environment } from 'src/environments/environment'
import { AcceptRejectPayoutModel } from '../../models/client-payout'

@Component({
	selector: 'app-sp-payout-details',
	templateUrl: './sp-payout-details.component.html',
	styleUrls: ['./sp-payout-details.component.scss'],
})
export class SpPayoutDetailsComponent implements OnInit {
	formData: FormGroup = new FormGroup({})
	subscription = new Subscription()
	formControl: any
	imgConfig: ImageUpload = {
		imageCropDimensions: 2.1,
		imageWidth: 800,
		imageHeight: 500,
	}
	@Input() viewMode: boolean = true
	@Output() flipped = new EventEmitter()
	imagePath = environment.attachmentPath
	@Input() payoutSpDetails!: payoutDetatilsSpPopUp
	branchPayoutMethods!: BranchPayoutMethod[]
	branchId: any
	acceptPayoutModel: AcceptRejectPayoutModel = {
		id: 0,
		payoutAmount: 0,
		notes: '',
		attachementUrl: '',
		spPayoutMethodId: 1,
	}
	methodIcon: boolean = false
	constructor(
		private dialog: MatDialog,
		private payoutService: PayoutService,
		private routeActivate: ActivatedRoute,
		public translate: TranslateService
	) {}

	ngOnInit(): void {
		this.routeActivate.params.subscribe(({ id }) => {
			this.getPayoutMethods(id)
			this.initForm()
			this.getController('sPpayoutMethodId').setValue(
				this.payoutSpDetails?.spPayoutMethodId
			)
		})
	}

	ngOnChanges() {
		this.initForm()
	}
	initForm() {
		this.formData = new FormGroup({
			notes: new FormControl(''),
			image: new FormControl(null, [Validators.required]),
			sPpayoutMethodId: new FormControl(this.payoutSpDetails?.spPayoutMethodId),
		})
	}
	uploadImage() {
		this.dialog
			.open(UploadImageComponent, {
				width: '752px',
				panelClass: 'overflow-y-auto',
				data: this.imgConfig,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						const body = new FormData()
						body.append('image', res.selectedFile)
						this.subscription.add(
							this.payoutService.UploadSpImage(body).subscribe((res: any) => {
								this.getController('image')?.setValue(res?.result?.url)
							})
						)
					}
				},
			})
	}

	getController(controlName: string) {
		return this.formData.controls[controlName] as FormControl
	}
	getPayoutMethods(id: any) {
		this.subscription.add(
			this.payoutService.getBranchPayoutMethods(id).subscribe((res: any) => {
				this.branchPayoutMethods = res.result
			})
		)
	}

	confirm() {
		this.acceptPayoutModel.id = this.payoutSpDetails.id
		this.acceptPayoutModel.attachementUrl = this.getController('image').value
		this.acceptPayoutModel.notes = this.getController('notes').value
		this.acceptPayoutModel.spPayoutMethodId =
			this.getController('sPpayoutMethodId').value

		this.subscription.add(
			this.payoutService
				.acceptSPPendingPayout(this.acceptPayoutModel)
				.subscribe((res: any) => {
					if (res) {
						this.flipped.emit(true)
					}
				})
		)
	}
}
